const UTM_STORAGE_KEY = 'uu_application_utm';
const UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'] as const;

type UTMField = typeof UTM_FIELDS[number];
export type UTMValues = Partial<Record<UTMField, string>>;

const canUseStorage = (): boolean => typeof window !== 'undefined' && 'localStorage' in window;

export const readStoredUTMValues = (): UTMValues => {
    if (!canUseStorage()) {
        return {};
    }

    try {
        const rawValue = window.localStorage.getItem(UTM_STORAGE_KEY);

        if (!rawValue) {
            return {};
        }

        const parsedValue = JSON.parse(rawValue) as unknown;

        if (!parsedValue || typeof parsedValue !== 'object') {
            return {};
        }

        return UTM_FIELDS.reduce<UTMValues>((accumulator, field) => {
            const value = (parsedValue as Record<string, unknown>)[field];

            if (typeof value === 'string' && value.trim() !== '') {
                accumulator[field] = value;
            }

            return accumulator;
        }, {});
    } catch {
        return {};
    }
};

const getUTMValuesFromLocation = (): UTMValues => {
    const url = new URL(window.location.href);

    return UTM_FIELDS.reduce<UTMValues>((accumulator, field) => {
        const value = url.searchParams.get(field);

        if (value && value.trim() !== '') {
            accumulator[field] = value.trim();
        }

        return accumulator;
    }, {});
};

export const persistUTMValues = (): void => {
    const urlUTMValues = getUTMValuesFromLocation();

    if (Object.keys(urlUTMValues).length === 0 || !canUseStorage()) {
        return;
    }

    try {
        const mergedUTMValues = {
            ...readStoredUTMValues(),
            ...urlUTMValues,
        };

        window.localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(mergedUTMValues));
    } catch {
        // Ignore storage write issues.
    }
};